import { createApp } from "vue/dist/vue.esm-bundler.js"; // for compiler build
import SignIn from "pages/SignIn/index.vue";
import { store } from "store/index.js";
import { addPlugins } from "./addPlugins.js";
import { VueReCaptcha } from "vue-recaptcha-v3";

document.addEventListener("DOMContentLoaded", () => {
  const element = document.getElementById("vue_sign_in");

  const data = element.dataset;

  const app = createApp(SignIn, { ...data }); // passing data from rails to app

  app.use(store);

  app.use(VueReCaptcha, {
    siteKey: process.env.RECAPTCHA3_SITE_KEY,
    loaderOptions: {
      autoHideBadge: true,
    },
  });

  addPlugins(app);

  app.mount("#vue_sign_in");
});
